<template>
  <div class="mb-6 relative">
    <!-- Label -->
    <label :for="id" class="block w-full mb-1 text-black">
      {{ label }}
      <span v-if="required" class="text-nucleus-error font-bold"> * </span>
    </label>

    <div class="relative">
      <!-- Input -->
      <input
        :id="id"
        class="block w-full border border-nucleus-darkestBlue rounded p-2 color-nucleus-darkestBlue focus:outline-none focus:ring-2 focus:ring-nucleus-primaryBlue focus:border-transparent"
        :class="{
          'border-nucleus-error focus:ring-nucleus-error': error,
          'bg-white': whiteBg,
          'bg-nucleus-lightestBlue': !whiteBg,
        }"
        :type="inputType"
        :value="value"
        :placeholder="placeholder"
        :autocomplete="autocompleteCheck()"
        :maxlength="maxLength"
        :min="min"
        :required="required"
        @input="updateValue"
        @focus="isFocused = true"
        @blur="isFocused = false"
      />

      <!-- Icon -->
      <span
        class="text-xl absolute top-1.5 right-2.5 cursor-pointer"
        :class="[
          'icon-' + icon,
          {
            'text-nucleus-darkestBlue': isFocused,
            'text-gray-400': !isFocused,
          },
        ]"
        :title="title"
        @click="togglePassword()"
      ></span>

      <span
        v-if="filter && value"
        class="text-3xl absolute top-0 right-1.5 flex justify-center items-center h-full cursor-pointer icon-clear text-nucleus-darkestBlue hover:text-nucleus-primaryBlue transition-all"
        :title="$t('titles.clearInput')"
        @click="clearInput()"
      ></span>
    </div>

    <!-- Error Message -->
    <div v-if="error" class="text-nucleus-error absolute text-xs">
      {{ error }}
    </div>
  </div>

  <!-- Hint -->
  <!-- <div
      v-else-if="hint"
      class="base-input--hint"
      :class="{ 'text-blue-500': isFocused, 'text-gray-500': !isFocused }"
    >
      {{ hint }}
    </div> -->
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:value", "updateInputType", "clearInput"],
  props: {
    inputType: String,
    label: String,
    icon: String,
    title: String,
    placeholder: String,
    value: String,
    autocomplete: String,
    error: String,
    required: Boolean,
    id: String,
    maxLength: Number,
    min: Number,
    whiteBg: Boolean,
    filter: Boolean,
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    // Update Model Value
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValue(event: any) {
      this.$emit("update:value", event.target.value);
    },
    togglePassword() {
      if (this.id.includes("password")) {
        const type = this.inputType === "password" ? "text" : "password";
        const icon = this.inputType === "password" ? "hide" : "show";
        console.log(type);

        this.$emit("updateInputType", { type: type, icon: icon });
      }
    },
    autocompleteCheck() {
      if (this.autocomplete) {
        return this.autocomplete;
      } else {
        return "on";
      }
    },
    clearInput() {
      this.$emit("clearInput");
    },
  },
})
export default class Input extends Vue {}
</script>

<style lang="scss" scoped>
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
